// 图片懒加载指令
const lazyload = {
  bind: function(el, binding) {
    el.$lazyload = {
      src: binding.value,
      loaded: false
    }
    
    // 初始状态设置占位图
    el.setAttribute('src', '')
    el.setAttribute('data-src', binding.value)
    
    // 检查是否在视口中
    lazyload.check(el)
    
    // 添加滚动监听
    if (!lazyload.observer) {
      lazyload.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target
            if (el.$lazyload && !el.$lazyload.loaded) {
              lazyload.load(el)
            }
          }
        })
      })
    }
    
    lazyload.observer.observe(el)
  },
  
  update: function(el, binding) {
    if (binding.value !== el.$lazyload.src) {
      el.$lazyload.src = binding.value
      el.$lazyload.loaded = false
      el.setAttribute('data-src', binding.value)
      el.setAttribute('src', '')
      lazyload.check(el)
    }
  },
  
  unbind: function(el) {
    if (lazyload.observer) {
      lazyload.observer.unobserve(el)
    }
    delete el.$lazyload
  },
  
  check: function(el) {
    // 检查元素是否在视口中
    const rect = el.getBoundingClientRect()
    const isVisible = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
    
    if (isVisible && !el.$lazyload.loaded) {
      lazyload.load(el)
    }
  },
  
  load: function(el) {
    const src = el.$lazyload.src
    if (!src) return
    
    const img = new Image()
    img.onload = function() {
      el.setAttribute('src', src)
      el.$lazyload.loaded = true
      el.classList.add('lazy-loaded')
    }
    img.onerror = function() {
      // 加载失败时的处理
      el.classList.add('lazy-error')
    }
    img.src = src
  }
}

export default lazyload